import { graphql } from "@server/gql";

export const getOrderQuery = graphql(/* GraphQL */ `
  query getOrder($cartId: String!, $locale: String!) {
    order(locale: $locale, cartId: $cartId) {
      orderId
      currencyCode
      totalOrderValue
      totalOrderValueExVatExShipping
      totalVat
      totalShipping
      totalShippingExVat
      couponCode
      items {
        partNo
        lineNo
        name
        brandName
        quantity
        totalDiscount
        unitPriceIncVat
        unitPriceExVat
      }
      customerData {
        email
        phoneNumber
        cellPhoneNumber
        firstName
        lastName
        street
        addressLine2
        city
        region
        postalCode
        country
      }
      customerDataSellTo {
        email
        phoneNumber
        cellPhoneNumber
        firstName
        lastName
        street
        addressLine2
        city
        region
        postalCode
        country
      }
      customerDataShipTo {
        email
        phoneNumber
        cellPhoneNumber
        firstName
        lastName
        street
        addressLine2
        city
        region
        postalCode
        country
      }
      cart {
        ...cart
      }
    }
  }
`);
